module.exports = __webpack_public_path__ + "static/img/lymphomap_logo.fa717734.png";